import React from 'react';
import {inject, observer} from 'mobx-react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
@withRouter
@inject('headerStore')
@observer
export default class extends React.Component {

  state = {value: ''};

  componentWillMount(){
    this.setState({value: this.props.location.pathname.split('/search/')[1] || ''});
    this.listenerRoute = this.props.history.listen(location => {
      if(!location.pathname.includes('search')){
        this.setState({value: ''});
        this.props.headerStore.setSearchState(false);
      }
    })
  }

  handleSearchClick = () => {
    this.props.headerStore.activateSearch();
    if(this.props.headerStore.isFocusedSearch){
      let searchInput = document.querySelector('.header-search input');
      searchInput.focus();
    }
  };

  handleChange = _.debounce((value) => {
    this.props.history.push(`/search/${value}`)
  },500);


  handleSubmit = e => {
    e.preventDefault();
    this.props.history.push(`/search/${this.state.value}`)
  };

  componentWillUnmount(){
    this.listenerRoute();
  }
  render(){
    const activeSearch = this.props.headerStore.isActiveSearch;

    return (
      <div className={classNames('header-search', {'active': activeSearch})}>
        <div className="header-search-inner">
          <form onSubmit={this.handleSubmit}>
          <input type="text"
                 value={this.state.value}
                 placeholder="Search"
                 onChange={(e) => {
                   this.setState({value: e.target.value});
                   // if(this.props.location.pathname.includes('search'))
                    this.handleChange(e.target.value)}}/>
            <span className="bar"/>
          </form>

            <i onClick={this.handleSearchClick} className="ic ic-search"/>
        </div>
        <i onClick={this.handleSearchClick} className="ic ic-close"/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/core/components/HeaderSearch.js